import React, { Component } from "react";

import ColorPicker from "./text/ColorPicker";

import Actions from "./common/Actions";
import Menu from "./text/TextMenu";
import FontFamilies from "./text/FontFamilies";

const Text = (props) =>  {

  let {
    onUpdated
  } = props

  let text = { ...props.text }

  let hasText = text.value != null

  const containerStyle = {
    opacity: hasText ? 1 : 0.5,
    pointerEvents: hasText ? "auto" : "none",
  };

  return (
    <div className="text">
      <Actions
        showAddButton
        text={text.value}
        onAddTextClicked={() => {
          text.value = "Text"
          onUpdated(text)
        }}
        onDeleteTextClicked={() => {
          text.value = null
          onUpdated(text)
        }}
        undoDisabled={props.undoDisabled}
        redoDisabled={props.redoDisabled}
        onUndoClicked={props.onUndoClicked}
        onRedoClicked={props.onRedoClicked}
      />
      <div>
        Choose Typography
        <FontFamilies
          containerStyle={containerStyle}
          active={text.font}
          onFontChanged={(font) => {
            text.font = font
            onUpdated(text)
          }}
        />
        <Menu
          containerStyle={containerStyle}
          onTextColorChanged={color => {
            text.color = color
            onUpdated(text)
          }}
          onTextBackgroundColorChanged={color => {
            text.backgroundColor = color
            onUpdated(text)
          }}
        />
      </div>
    </div>
  );
}

export default Text
